'use client';

import type { FC, ReactNode, MouseEventHandler } from 'react';

import { Link } from '../../../../Link/Link';

export type SlotEquivalentLinksItemProps = {
  href: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

export const SlotEquivalentLinksItem: FC<SlotEquivalentLinksItemProps> = ({
  href,
  children,
  onClick,
}) => (
  <li className="border-color-grey border-b">
    <Link className="flex items-center gap-3 px-2 py-1" href={href} onClick={onClick}>
      {children}
    </Link>
  </li>
);
